// eslint-disable-next-line
export const openBlobDocument = (blob) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  // Create a new window or tab to display the PDF
  window.open(downloadUrl, '_blank');
  window.URL.revokeObjectURL(downloadUrl);
};
